"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class PipelineFactory {
    static create(data) {
        const instanceMap = {
            'Closed Deal': _1.CompModel,
            'Contract': _1.ContractModel,
            'Listing': _1.ListingModel,
            'Pursuit': _1.PursuitModel
        };
        const model = instanceMap[data.instanceType];
        if (!model) {
            throw new Error(`Unable to create instance for ${data.instanceType}`);
        }
        return new model(data);
    }
}
exports.PipelineFactory = PipelineFactory;
//# sourceMappingURL=pipeline.factory.js.map